(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cca-home-faqs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cca-inbox-trigger')) {
    customElements.define('cca-inbox-trigger', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.handleClick = this.openInbox.bind(this);
        this.button?.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
        this.finish(false, false);
      }

      findInbox() {
        const inbox = document.getElementById('ShopifyChat') || document.querySelector('shopify-chat');
        const directLauncher = inbox?.shadowRoot?.querySelector('button');
        const runtime = inbox?.shadowRoot?.querySelector('shopify-agent-runtime');
        const runtimeRoot = runtime?.shadowRoot;
        const launcher = directLauncher || runtimeRoot?.querySelector('button[part="activator"]');
        const panel = runtimeRoot?.querySelector('[role="dialog"]');
        const isOpen = inbox
          && (
            inbox.getAttribute('is-open') === 'true'
            || inbox.hasAttribute('open')
            || launcher?.getAttribute('aria-expanded') === 'true'
            || (panel && !panel.hasAttribute('inert'))
          );

        return { inbox, launcher, isOpen };
      }

      openInbox() {
        if (this.opening || !this.button) return;
        this.opening = true;
        this.lastLaunch = 0;
        this.openSince = 0;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        if (this.status) this.status.textContent = this.dataset.loading;

        const attempt = () => {
          const { launcher, isOpen } = this.findInbox();
          if (isOpen) {
            if (!this.openSince) this.openSince = Date.now();
            if (Date.now() - this.openSince >= 350) this.finish(true);
            return;
          }

          this.openSince = 0;
          if (launcher && Date.now() - this.lastLaunch >= 750) {
            this.lastLaunch = Date.now();
            launcher.click();
          }
        };

        attempt();
        this.observer = new MutationObserver(attempt);
        this.observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
        this.retry = window.setInterval(attempt, 100);
        this.timeout = window.setTimeout(() => this.finish(false), 8000);
      }

      finish(opened, updateStatus = true) {
        this.observer?.disconnect();
        if (this.retry) window.clearInterval(this.retry);
        if (this.timeout) window.clearTimeout(this.timeout);
        this.observer = null;
        this.retry = null;
        this.timeout = null;
        this.opening = false;
        this.lastLaunch = 0;
        this.openSince = 0;

        if (this.button) {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }

        if (updateStatus && this.status) {
          this.status.textContent = opened ? this.dataset.opened : this.dataset.unavailable;
        }
      }
    });
  }

  document.querySelectorAll('[data-cca-faq-list]').forEach((list) => {
    if (list.dataset.ccaFaqBound === 'true') return;
    list.dataset.ccaFaqBound = 'true';

    const items = list.querySelectorAll('[data-cca-faq-item]');
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cca-master-bottom-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cca-legacy-bottom]').forEach((section) => {
    if (section.dataset.collapsibleReady === 'true') return;
    const content = section.querySelector('[data-cca-legacy-content]');
    const toggle = section.querySelector('[data-cca-legacy-toggle]');
    if (!content || !toggle) return;

    section.dataset.collapsibleReady = 'true';
    const needsDisclosure = content.scrollHeight > content.clientHeight + 2;
    if (!needsDisclosure) return;

    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      content.dataset.expanded = String(!expanded);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clc-measure-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clc-measure-guide')) {
    let measureApiPromise;
    const measureApi = () => {
      if (window.YT?.Player) return Promise.resolve(window.YT);
      if (measureApiPromise) return measureApiPromise;
      measureApiPromise = new Promise((resolve, reject) => {
        const previous = window.onYouTubeIframeAPIReady;
        const timer = setTimeout(() => reject(new Error('Player API timed out')), 12000);
        window.onYouTubeIframeAPIReady = () => {
          clearTimeout(timer);
          try { if (typeof previous === 'function') previous(); }
          finally { resolve(window.YT); }
        };
        if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
          const script = document.createElement('script');
          script.src = 'https://www.youtube.com/iframe_api';
          script.async = true;
          script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Player API unavailable')); };
          document.head.appendChild(script);
        }
      }).catch((error) => { measureApiPromise = null; throw error; });
      return measureApiPromise;
    };
    customElements.define('clc-measure-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.tabs = Array.from(this.querySelectorAll('.clc-measure__choices a'));
        this.panels = Array.from(this.querySelectorAll('.clc-measure__panel'));
        this.activeIndex = -1;
        this.players = new Map();
        this.classList.add('is-enhanced');
        this.querySelector('.clc-measure__choices').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('tabindex', '0');
          tab.addEventListener('click', (event) => { event.preventDefault(); this.activate(index); }, {signal: this.controller.signal});
          tab.addEventListener('keydown', (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey) return;
            const offsets = {ArrowRight: 1, ArrowLeft: -1};
            let next;
            if (event.key in offsets) next = (index + offsets[event.key] + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key === ' ') { event.preventDefault(); this.activate(index); return; }
            else return;
            event.preventDefault();
            this.tabs.forEach((item, position) => item.tabIndex = position === next ? 0 : -1);
            this.tabs[next].focus();
          }, {signal: this.controller.signal});
          const panel = this.panels[index];
          panel.querySelector('.clc-measure__poster').addEventListener('click', (event) => {
            event.preventDefault();
            this.play(panel);
          }, {signal: this.controller.signal});
        });
        this.activate(0);
      }
      activate(index) {
        if (this.activeIndex !== index) {
          const previous = this.panels[this.activeIndex];
          const record = this.players.get(previous);
          if (record) {
            record.requested = false;
            if (record.ready) record.player.pauseVideo();
            previous.querySelector('.clc-measure__poster').hidden = false;
            previous.querySelector('.clc-measure__frame').setAttribute('aria-hidden', 'true');
            if (record.ready) record.player.getIframe().tabIndex = -1;
          }
        }
        this.tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[position].hidden = !selected;
        });
        this.activeIndex = index;
        this.prepare(this.panels[index]);
      }
      start(panel, record) {
        if (!record.ready || !record.requested || panel.hidden || record.cancelled) return;
        record.player.playVideo();
        panel.querySelector('.clc-measure__poster').hidden = true;
        panel.querySelector('.clc-measure__frame').setAttribute('aria-hidden', 'false');
        record.player.getIframe().tabIndex = 0;
      }
      play(panel) {
        const record = this.prepare(panel);
        record.requested = true;
        this.start(panel, record);
      }
      prepare(panel) {
        if (this.players.has(panel)) return this.players.get(panel);
        const record = {ready: false, requested: false, cancelled: false};
        this.players.set(panel, record);
        const media = panel.querySelector('.clc-measure__media');
        const poster = panel.querySelector('.clc-measure__poster');
        const error = panel.querySelector('.clc-measure__error');
        const label = panel.querySelector('.clc-measure__poster-label');
        media.dataset.state = 'preparing';
        error.hidden = true;
        label.textContent = 'Play video';
        const unavailable = () => {
          if (record.cancelled) return;
          record.cancelled = true;
          clearTimeout(record.timer);
          if (record.player) record.player.destroy();
          this.players.delete(panel);
          media.dataset.state = 'error';
          poster.hidden = false;
          if (record.requested) {
            label.textContent = 'Try again';
            error.hidden = false;
          }
        };
        record.timer = setTimeout(unavailable, 12000);
        measureApi().then((api) => {
          if (record.cancelled || !this.isConnected) return;
          const mount = document.createElement('div');
          panel.querySelector('.clc-measure__frame').replaceChildren(mount);
          record.player = new api.Player(mount, {
            videoId: media.dataset.videoId,
            width: '100%', height: '100%',
            playerVars: {autoplay: 0, playsinline: 1, rel: 0, origin: window.location.origin},
            events: {
              onReady: (event) => {
                if (record.cancelled) { event.target.destroy(); return; }
                clearTimeout(record.timer);
                record.ready = true;
                media.dataset.state = 'ready';
                event.target.getIframe().title = 'How to measure: ' + panel.querySelector('h2').textContent;
                event.target.getIframe().tabIndex = -1;
                this.start(panel, record);
              },
              onError: unavailable
            }
          });
        }).catch(unavailable);
        return record;
      }
      disconnectedCallback() {
        this.players.forEach((record) => {
          record.cancelled = true;
          clearTimeout(record.timer);
          if (record.player) record.player.destroy();
        });
        this.players.clear();
        this.panels.forEach((panel) => {
          panel.querySelector('.clc-measure__frame').replaceChildren();
          panel.querySelector('.clc-measure__poster').hidden = false;
        });
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
